"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FilterDTO {
    constructor({ id, preset = false, active = false, count = 0, values, group }) {
        if (!id || typeof id !== 'string') {
            throw new TypeError('missing param ID for FilterDTO');
        }
        this.$id = id;
        this.$preset = preset;
        this.active = active;
        this.$count = count;
        if (Array.isArray(values)) {
            this.$values = [...values];
        }
        [this.$filterGroup] = this.id.split('.');
        this.$group = group || this.$filterGroup;
    }
    static get types() {
        return {
            RANGE_FILTER: 'range-filter',
            MINMAX_RANGE_FILTER: 'minmax-range-filter',
            BASIC_FILTER: 'basic-filter',
            LOCATION_FILTER: 'location-filter',
            UNKNOWN_FILTER: 'unknown-filter',
        };
    }
    static initFromFilterString(filterString_ = '', active_ = false, preset_ = false, group_) {
        const splittedFilter = filterString_.split(':');
        const id = splittedFilter.shift();
        let values = null;
        if (splittedFilter.length) {
            values = splittedFilter.shift().split('_');
        }
        return new FilterDTO({
            id,
            active: active_,
            values,
            preset: preset_,
            group: group_,
        });
    }
    static castObjectToFilterDTO(filterDtoObject) {
        if (!filterDtoObject) {
            return null;
        }
        return new FilterDTO({
            id: filterDtoObject.$id,
            active: filterDtoObject.active,
            values: filterDtoObject.$values,
            preset: filterDtoObject.$preset,
            count: filterDtoObject.$count || 0,
            group: filterDtoObject.$group,
        });
    }
    set group(groupname) {
        this.$group = groupname;
    }
    get filterGroup() {
        return this.$filterGroup;
    }
    get group() {
        return this.$group;
    }
    get count() {
        return this.$count;
    }
    get id() {
        return this.$id;
    }
    get values() {
        return this.$values;
    }
    set values(valuesArr) {
        this.$values = valuesArr;
    }
    isActive() {
        return this.active === true;
    }
    isPreset() {
        return this.$preset === true;
    }
    get type() {
        if (this.values) {
            if (this.values.length === 2) {
                if (this.values[0] && this.values[1]) {
                    return FilterDTO.types.MINMAX_RANGE_FILTER;
                }
                return FilterDTO.types.RANGE_FILTER;
            }
            if (this.values.length === 5) {
                return FilterDTO.types.LOCATION_FILTER;
            }
        }
        return FilterDTO.types.BASIC_FILTER;
    }
    static getClonedFilter(filterDTO) {
        let clonedFilter = null;
        if (filterDTO) {
            clonedFilter = FilterDTO.castObjectToFilterDTO(filterDTO);
            clonedFilter.clone = true;
        }
        return clonedFilter;
    }
    activateFilter() {
        this.active = true;
    }
    removeRangeValue(valueToRemove) {
        if (valueToRemove.toLowerCase() === 'min') {
            this.$values[0] = '';
        }
        else {
            this.$values[1] = '';
        }
    }
    deactivateFilter() {
        if (!this.isPreset()) {
            this.active = false;
            switch (this.type) {
                case FilterDTO.types.RANGE_FILTER:
                case FilterDTO.types.MINMAX_RANGE_FILTER:
                    this.values = ['', ''];
                    break;
                case FilterDTO.types.LOCATION_FILTER:
                    this.setLocation();
                    break;
                default:
                    this.values = null;
            }
        }
    }
    static isMemberOfSyntheticFilterGroup(filterObject) {
        const filterDTO = FilterDTO.castObjectToFilterDTO(filterObject);
        return filterDTO.filterGroup !== filterDTO.group;
    }
    toString() {
        let filterString = this.id;
        if (this.values) {
            filterString = `${filterString}:${this.values.join('_')}`;
        }
        return filterString;
    }
    setLocation(locationObject = {}) {
        this.values = [
            locationObject.latitude,
            locationObject.longitude,
            locationObject.distance,
            locationObject.distanceUnit,
            locationObject.location,
        ];
    }
}
exports.default = FilterDTO;
//# sourceMappingURL=filter-dto.js.map